export default async ({ store, redirect }) => {
  if (store.state.auth.user?.isBusiness) {
    return redirect({ path: '/' })
  }
}
